<template>
  <div>
    <RF-Dialog
      :cpntStatus='statusGeral'
      :cpntLargura='"850px"'
      :cpntOnFecharDialog='filtroFecharDialog'>
      <template slot='titulo'>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        Filtrar {{ cpntNome }}

        <RF-Toggles--2 v-if="cpntMostrarFiltrarNenhum === true && formulario.hasOwnProperty('filtroNenhum')" style="vertical-align: -10px;"
          :data-time="time" :class='"rf-toggles rf-field-tamanho-" + (formulario.filtroNenhum.hasOwnProperty("tamanho") ? formulario.filtroNenhum.tamanho : 0)'

          :cpntStatus='""'
          :cpntId='formulario.id + "-filtroNenhum"'
          :cpntClassDivField='formulario.filtroNenhum.classDivField'
          :cpntNome='formulario.filtroNenhum.nome'
          :cpntValue='formulario.filtroNenhum.value'
          :cpntDisabled='formulario.filtroNenhum.disabled'
          :cpntMostrar='formulario.filtroNenhum.mostrar'
          :cpntMensagem='formulario.filtroNenhum.mensagem'
          :cpntMensagemTipo='formulario.filtroNenhum.mensagemTipo'
          :cpntOptions='formulario.filtroNenhum.options'
          :cpntKeyValue='formulario.filtroNenhum.keyValue'
          :cpntKeyMostra='formulario.filtroNenhum.keyMostra'
          :cpntExplica='formulario.filtroNenhum.explica'
          :cpntTabIndex='formulario.filtroNenhum.tabIndex'

          :cpntOnChange='formulario.filtroNenhum.onChange'
          :cpntOnBlur='formulario.filtroNenhum.onBlur'
          :ref='formulario.filtroNenhum.tipo'
        ></RF-Toggles--2>
      </template>

      <template slot='conteudo' v-if='Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1'>
        <div v-if="formulario.hasOwnProperty('filtroNenhum') && formulario.filtroNenhum.value === 'n'">
          <div class="sem-filtro">
            <RF-Icones
              :cpntId='formulario.id + "-icone-sem-pag"'
              :cpntIcone='"alerta"'
              :cpntIconeClass='"rf-icon-amarelo"'
            ></RF-Icones>
            Não mostrar {{ cpntNome }} no relatório.
          </div>
        </div>
        <div v-else style="padding-top: 20px;">
          <table class="cpnt-filtros">
            <tr v-for="(campo, index) in formulario.field" :key="index">
              <td>
                {{ campo.nome }}
              </td>
              <td>
                <RF-Componente
                  :data-time='time'
                  :cpntTamanho='campo.tamanho'
                  :cpntModelo='campo.tipo'
                  :cpntStatus='campo.status'
                  :cpntId='campo.id'
                  :cpntClassDivField='campo.classDivField'
                  :cpntNome='""'
                  :cpntValue='campo.value'
                  :cpntValueRef='campo.valueRef'
                  :cpntOptions='campo.options'
                  :cpntKeyValue='campo.keyValue'
                  :cpntKeyMostra='campo.keyMostra'
                  :cpntAutoComplete='campo.autocomplete'
                  :cpntDisabled='campo.disabled'
                  :cpntMostrar='campo.mostrar'
                  :cpntMensagem='campo.mensagem'
                  :cpntSelecioneNome='campo.selecioneNome'
                  :cpntSelecioneValue='campo.selecioneValue'
                  :cpntMensagemTipo='campo.mensagemTipo'
                  :cpntAdicinarOption='campo.adicinarOption'
                  :cpntMultiple='campo.multiple'
                  :cpntAllRegistro='campo.allRegistro'
                  :cpntExplica='campo.explica'
                  :cpntTabIndex='campo.tabIndex'
                  :cpntOptionInicialNome='campo.optionInicialNome'
                  :cpntOptionInicialValue='campo.optionInicialValue'

                  :cpntOnChange='campo.onChange'
                  :cpntOnBlur='campo.onBlur'
                  :ref='campo.tipo'
                ></RF-Componente>
              </td>
            </tr>

            <tr :data-time="time"  v-if='Object.keys(formulario.buttons).length >= 1'>
              <td v-for='(button, index) in formulario.buttons' :key="index" style="text-align: center;" colspan="2">
                <RF-Button :key="index"
                  :data-time='time'

                  :cpntStatus='button.status' 
                  :cpntId='button.id' 
                  :cpntTexto='button.texto' 
                  :cpntClass='button.class'
                  :cpntMostrar='button.mostrar'
                  :cpntTabIndex='button.tabIndex'

                  @onClickButton='button.onClick'
                ></RF-Button>
              </td>
            </tr>

            <tr :data-time="time" v-if='Object.keys(tabela).length >= 1 && [ "", null, undefined ].indexOf(tabela.acoes) === -1 && Object.keys(tabela.acoes).length >= 1'>
              <td colspan="2">
                <div class="cpnt-filtros-titulo" v-if="[ '', null, undefined ].indexOf(tabela.filtros) === -1">
                  Filtrar:
                  <input v-model="filtroInput" class="form-control" style="width: 200px; display: inline-block; padding: 1px 12px; height: 30px; margin: 4px 0px;"/>
                </div>

                <RF-Tabela
                  :data-time='time'

                  :cpntTime='time'
                  :cpntId='tabela.id'
                  :cpntStatus='tabela.status'
                  :cpntButtonImprimir='tabela.acoes.btImprimir'
                  :cpntButtonImprimirOculta='tabela.acoes.btImprimirOculta'
                  :cpntButtonAtualizar='tabela.acoes.btAtualizar'
                  :cpntFraseTop='tabela.fraseTop'
                  :cpntInfoTabela='tabela.infoTabela'
                  :cpntColuna='tabela.coluna'
                  :cpntLinha='tabela.linhaTab'
                  :cpntCountAll='tabela.countAll'
                  :cpntColspan='tabela.colspan'
                  :cpntButtonsAcoes='tabela.acoes.buttons'
                  :cpntMper='tabela.mper'
                  :cpntPagina='tabela.pagina'
                  :cpntCheckboxEditar='tabela.checkboxEditar'
                  :cpntFieldsEditar='tabela.acoes.fields'
                  :cpntCheckboxChecked='tabela.checkbox'

                  :cpntOnRefreshTabela='filtroBuscarProduto'
                  @cpntUpdateModel="cpntCheckboxUpdateModel"
                  :ref='tabela.id'
                ></RF-Tabela>
              </td>
            </tr>
          </table>
        </div>
      </template>

      <template slot="rodape" v-if='Object.keys(formulario).length >= 1 && Object.keys(formulario.buttonsFinais).length >= 1 && ((Object.keys(tabela).length >= 1 && [ "", null, undefined ].indexOf(tabela.acoes) === -1 && Object.keys(tabela.acoes).length >= 1 && tabela.linha.length >= 1) || (formulario.hasOwnProperty("filtroNenhum") && formulario.filtroNenhum.value !== formulario.filtroNenhum.valueIni))'>
        <div :data-time="time" class="button-finais">
          <div v-for='(button, index) in formulario.buttonsFinais' :key="index">
            <RF-Button :key="index"
              :data-time='time'

              :cpntStatus='button.status' 
              :cpntId='button.id' 
              :cpntTexto='button.texto' 
              :cpntClass='button.class'
              :cpntMostrar='button.mostrar'
              :cpntTabIndex='button.tabIndex'

              @onClickButton='button.onClick'
            ></RF-Button>
          </div>
        </div>
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
  .cpnt-filtros {
    width: 100%;
    /* margin-top: 20px; */
  }
  .cpnt-filtros > tr > td {
    text-align: left;
    vertical-align: middle;
    padding: 5px 0px;
  }
  .cpnt-filtros > tr > td:first-child {
    width: 105px;
  }
  .button-finais {
    width: 100%;
    margin: 10px 0px;
    text-align: right;
  }
    .button-finais > div:last-child {
      margin-right: 35px;
    }
    .button-finais > div {
      display: inline-block;
      margin: 0px 5px;
    }

.cpnt-filtros-titulo {
  width: calc(100% + 1px);
  padding: 2px 5px;
  font-size: var(--font-base-soma-11);
  background-color: #f4f9fe;
  text-decoration: none;
  border-top: 1px solid #d5dee5;
  border-left: 1px solid #d5dee5;
  border-right: 1px solid #d5dee5;
  /* border-bottom: 1px solid #d5dee5; */
}
</style>

<style>
.sem-filtro {
    text-align: center;
    width: 400px;
    margin: 0 auto;
    font-weight: 600;

    background: #efefef;
    border: 1px solid #c6c4c4;
    padding: 20px;
    border-radius: 10px;

    margin-top: 20px;
  }
    .sem-filtro > span {
      display: block;
      margin-bottom: 20px;
    }
    .sem-filtro > span > svg {
      font-size: var(--font-base-soma-30);
    }

.cpnt-filtros > tr > td > div > div {
  width: 100% !important;
  max-width: 100% !important;
  text-align: left !important;
}
  .cpnt-filtros > tr > td > div > div > div {
    text-align: left !important;
  }
    .cpnt-filtros > tr > td > div > div > div > div {
      /* padding-top: 20px; */
    }
      .cpnt-filtros > tr > td > div > div > div,
      .cpnt-filtros > tr > td > div > div > div > div > div {
        margin-bottom: 0px !important;
      }
      .cpnt-filtros > tr > td > div > div > div > div > button {
        margin-top: 0px !important;
      }
.tab-tabela-filtros-produtos-th-nome,
.tab-tabela-filtros-produtos-td-nome {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
}
.tab-tabela-filtros-produtos-td-nome {
  text-align: left !important;
}
  .tab-tabela-filtros-produtos-td-nome > div {
    width: 100% !important;
    text-align: left !important;
    white-space: initial !important;
  }
</style>

<script>
  export default {
    props: {
      cpntTipo: {
        required: true
      },
      cpntNome: {
        required: true,
        type: String
      },
      cpntFiltrarNenhum: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntMostrarFiltrarNenhum: {
        required: false,
        default: function () {
          return false
        }
      },
      cpntCheckbox: {
        required: false,
        type: Array,
        default: function () {
          return []
        }
      },
      cpntFiltros: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },
      cpntFiltroFecharDialog: {
        required: true
      }
    },
    components: {
      'RF-Toggles--2': () => import('@/components/rf-geral/toggles/RF-Toggles--2.vue')
    },
    data: function () {
      return {
        time: 0,
        statusGeral: '',
        formulario: {},
        tabela: {},
        filtroInput: ''
      }
    },
    mounted: function () {
      this.filtroIniciar()
    },
    methods: {
      cpntCheckboxUpdateModel: function (event) {
        // IMPORTA A FUNÇÃO PARA REMOVER A CONTA DO CS
        const CPNT_UPDATE_MODEL = require('@/assets/js/Funcoes-Gerais.js').CPNT_UPDATE_MODEL

        // CHAMA A FUNÇÃO PARA REMOVER A CONTA DO LS_WEB
        CPNT_UPDATE_MODEL(this, event)
      },
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      // => FUNÇÕES GERAIS DO COMPONENT
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      filtroIniciar: function () {
        // SETA O STATUS DA TELA
        this.filtroSetarStatusGeral('carregando')

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        this.formulario = {
          status: '',
          id: 'form-filtros--' + this.cpntTipo,
          focus: '',
          field: {},
          buttons: {},
          buttonsFinais: {},
          campos: 0,
          iniciados: [],
          tabIndexFieldGeral: 1000,
          tabIndexButtonGeral: 1000
        }
        
        switch (this.cpntTipo) {
          case 'produtos':
            // SETA O TOTAL DE CAMPOS QUE SERÁ CARREGADO
            this.formulario.campos = 2

            // CRIA O FILTRO DE CATEGORIA DE PRODUTO
            this.filtroProdutoCategoria(this)

            // CRIA O FILTRO DE CATEGORIA DE PRODUTO
            this.filtroProdutoMarca(this)
            break

          case 'servicos':
            // SETA O TOTAL DE CAMPOS QUE SERÁ CARREGADO
            this.formulario.campos = 1

            // CRIA O FILTRO DE CATEGORIA DE SERVIÇO
            this.filtroServicoCategoria(this)
            break

          case 'veiculos':
            // SETA O TOTAL DE CAMPOS QUE SERÁ CARREGADO
            this.formulario.campos = 2

            // CRIA O FILTRO DE CONTATO
            this.filtroVeiculoContato(this)

            // CRIA O FILTRO DE MODELO
            this.filtroVeiculoMarca(this)

            // CRIA O FILTRO DE MODELO
            this.filtroVeiculoModelo(this)
            break

          case 'pet':
            // SETA O TOTAL DE CAMPOS QUE SERÁ CARREGADO
            this.formulario.campos = 3

            // CRIA O FILTRO DE CONTATO
            this.filtroVeiculoContato(this)

            // CRIA O FILTRO DE MODELO
            this.filtroPetEspecie(this)

            // CRIA O FILTRO DE MODELO
            this.filtroPetRaca(this)
            break

          case 'contatos':
            // SETA O TOTAL DE CAMPOS QUE SERÁ CARREGADO
            this.formulario.campos = 1

            // CRIA O FILTRO DE TIPO DE CONTATO
            this.filtroContatoTipo(this)
            break
        
          default:
            this.filtroSetarStatusGeral({ loc: 'WEB', cod: 500, err: '(1) - Erro ao identificar o tipo (' + this.cpntTipo + ') de filtro a ser utilizado.' })
            break
        }
      },
      // filtroOnCheckboxAtualiza: function (coluna = null, checkbox = null) {
      //   if (coluna !== null && checkbox !== null) {
      //     if (this.tabela.linhaTab.length !== this.tabela.linha.length) {
      //       // SOMA OS CHECKBOX MARCADOS SE ESTIVER APLICANDO FILTRO
      //       checkbox = checkbox.concat(this.tabela.checkbox)

      //       // REMOVER VALORES DUPLICADOS
      //       checkbox = checkbox.filter((v, i, a) => a.indexOf(v) === i)
      //     }

      //     // SETA O VALOR RECEBIDO NO CHECKBOX
      //     this.tabela.checkbox = checkbox
          
      //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //     this.time = new Date().getTime()
      //   }
      // },
      filtroFinalizarCarregamento: function (fields) {
        var self = this

        // SETA OS CAMPOS RECEBIDOS
        self.formulario.field = fields

        // INICIA A FUNÇÃO DE CALLBACK
        var callback = null

        switch (self.cpntTipo) {
          case 'produtos':
            callback = self.filtroTabelaProdutoIniciar
            break

          case 'servicos':
            callback = self.filtroTabelaServicoIniciar
            break

          case 'contatos':
            callback = self.filtroTabelaContatoIniciar
            break

          case 'veiculos':
            callback = self.filtroTabelaVeiculoIniciar
            break

          case 'pet':
            callback = self.filtroTabelaPetIniciar
            break
        
          default:
            self.filtroSetarStatusGeral({ loc: 'WEB', cod: 500, err: '(2) - Erro ao identificar o tipo (' + self.cpntTipo + ') de filtro a ser utilizado.' })
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        if (callback !== null) {
          // SETA OS BOTÕES DA TELA
          self.formulario.buttons = {
            pesquisa: {
              id: self.formulario.id + '-env',
              status: '',
              texto: 'Pesquisar',
              class: [ 'btn', 'btn-default', 'btn-sm' ],
              mostrar: true,
              disabled: false,
              onClick: function () {
                // SETA O STATUS DE PESQUISANDO
                self.formulario.buttons.pesquisa.status = 'carregando'

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                // EXECUTA A FUNÇÃO CALLBACK
                callback()
              }
            }
          }

          // SETA OS BOTÕES DA TELA
          self.formulario.buttonsFinais = {
            limpar: {
              id: self.formulario.id + '-env',
              status: '',
              texto: 'Limpar Filtros',
              class: [ 'btn', 'btn-default', 'btn-sm' ],
              mostrar: true,
              disabled: false,
              onClick: self.filtrosLimpar
            },
            aplicar: {
              id: self.formulario.id + '-env',
              status: '',
              texto: 'Aplicar Filtros',
              class: [ 'btn', 'btn-primary' ],
              mostrar: true,
              disabled: false,
              onClick: self.filtrosAplicar
            }
          }

          if (self.cpntFiltrarNenhum !== null) {
            self.formulario.filtroNenhum = {
              tamanho: 51,
              tipo: 'toggles--2',
              nome: '',
              width: '150px',
              value: self.cpntFiltrarNenhum === true ? 'n' : 's',
              valueIni: self.cpntFiltrarNenhum === true ? 'n' : 's',
              options: [ { id: 's', nome: 'Mostrar ' + self.cpntNome }, { id: 'n', nome: 'Não mostrar ' + self.cpntNome } ],
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              mostrar: true,
              tabIndex: self.formulario.tabIndexFieldGeral,
              onChange: function (value) {
                // SETA SE A OPÇÃO DE FILTRAR FOI MARCADA
                self.formulario.filtroNenhum.value = value

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              }
            }
          }

          // SETA O STATUS DA TELA
          self.filtroSetarStatusGeral('')
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS DA TABELA
          if ([ 't', '' ].indexOf(self.cpntCheckbox.join()) === -1) {
            callback()
          }
        }
      },
      filtrosAplicar: function () {
        // SETA OS FILTROS QUE SERÁ APLICADO
        var filtros = {}

        // VERIFICA SE FOI SELECIONADO ALGUM FILTRO
        for (var key in this.formulario.field) {
          filtros[key] = this.formulario.field[key].value
        }
        
        // CHAMA A FUNÇÃO PARA FECHAR A TELA
        this.filtroVerificaValorMarcadoExisteTabela(function (self, checkbox) {
          self.filtroFecharDialog(true, checkbox, filtros)
        })
      },
      filtrosLimpar: function () {
        // VERIFICA SE DEVE INFORMAR OS VALORES
        if ([ '', null, undefined ].indexOf(this.tabela.coluna[0].checked) === -1) {
          this.tabela.coluna[0].checked = []
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // CHAMA A FUNÇÃO PARA FECHAR A TELA
        this.cpntFiltroFecharDialog(true, [], {})
      },
      filtroVerificaValorMarcadoExisteTabela: function (callback = null, iniciando = false) {
        // SETA OS VALORES QUE SERÁ ENVIADO
        var value = []

        if (this.formulario.hasOwnProperty('filtroNenhum') && this.formulario.filtroNenhum.value === 'n') {
          // LIMPA O VETOR DE DADOS
          value = [ "NENHUM" ]
        } else {
          // if (this.$store.state.FUN_VALIDA_INFORMACAO(this.tabela.coluna) === -1) {
          //   // PEGA O ID DA COLUNA
          //   var indexColuna = this.tabela.coluna.findIndex(item => item.chave === this.tabela.checkboxEditar && item.tipo === 'RF-Checkbox')
          // }

          // PEGA OS VALOES DO CAMPO
          value = this.tabela.checkbox.id

          // INICIA A VARIVIAVEL
          var key = ''

          if ([ 't', '' ].indexOf(value.join()) === -1) {
            // PEGA AS LINHA MARCADAS
            var marcados = this.tabela.linha.filter(item => [ '', null, undefined ].indexOf(item[this.tabela.checkboxEditar]) === -1 && value.indexOf(item[this.tabela.checkboxEditar]) !== -1)

            // LIMPA O VETOR DE DADOS
            value = []

            // ADICIONA OS VALORES ATUALIZADOS
            for (key in marcados) {
              value.push(marcados[key][this.tabela.checkboxEditar])
            }

            // PEGA OS VALOES DO CAMPO
            this.tabela.checkbox.id = value
          } else if (iniciando === true) {
            // LIMPA O VETOR DE DADOS
            value = []

            // ADICIONA TODOS OS VALORES MARCADOS
            for (key in this.tabela.linha) {
              // // SETA A COR DA LINHA COMO MARCADA
              // this.tabela.linha[key].rfClassTrFocus = ''

              // ADICIONA O CHECKBOX MARCADO NA LINHA
              value.push(this.tabela.linha[key][this.tabela.checkboxEditar])
            }

            // // PEGA OS VALOES DO CAMPO
            this.tabela.checkbox.id = value
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null) {
          callback(this, value)
        }
      },
      filtroFecharDialog: function (atualizar, checkbox = [], filtros = {}) {
        if (atualizar === true && checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [400]: Selecione ao menos um registro antes de continuar.', 'warning')
        } else if (atualizar === false || (atualizar === true && checkbox.length >= 1)) {
          this.cpntFiltroFecharDialog(atualizar, checkbox, filtros)
        }
      },
      filtroSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      filtrosFinalizar: function (funcao) {
        // SALVA A CONTAGEM DE FINALIZAÇÕES
        this.formulario.iniciados.push(funcao)

        // REMOVER VALORES DUPLICADOS
        this.formulario.iniciados = this.formulario.iniciados.filter((v, i, a) => a.indexOf(v) === i)

        if (this.formulario.iniciados.length === this.formulario.campos) {
          // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
          this.$store.state.FUN_CREATE_KEY_FIELDS(this.formulario.field, this.filtroFinalizarCarregamento)
        }
      },
      filtroParaRelatorioOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.formulario.field[index[2]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index[2]].mensagem = ''
        this.formulario.field[index[2]].mensagemTipo = ''

        // VERIFICA A AÇÃO QUE DEVE SER FEITA EM CADA CAMPO
        switch (this.cpntTipo + '_' + index[2]) {
          case 'veiculos_marca':
            this.filtroVeiculoModelo(this)
            break

          case 'pet_especie':
            this.filtroPetRaca(this)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      // ====================================================================================================================

      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      // => FUNÇÕES SERVICO
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      filtroServicoCategoria: function (self, qtdeTotal = null) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.categoria = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Categoria: ',
              id: self.formulario.id + '--categoria',
              multiple: true,
              allRegistro: 'Todos',
              value: this.cpntFiltros.categoria,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (qtdeTotal === -1 || self.formulario.field.categoria.options.length < qtdeTotal) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: self.formulario.field.categoria.options.length, qty: 1000 }, field: { id: null, nome: null } }
    
            self.$store.state.comunicaAPI('/servico/categoria/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.formulario.field.categoria.options = self.formulario.field.categoria.options.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroServicoCategoria(self, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          } else {
            self.filtrosFinalizar('filtroServicoCategoria')
          } 
        }
      },
      filtroTabelaServicoIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'tabela-filtros-' + this.cpntTipo,
          checkbox: { id: this.cpntCheckbox },
          linha: [],
          requestId: 0,
          montarTabelaCompleta: false,
          // filtros: {
          //   id: '=',
          //   nome: null
          // }
        }

        // SETA AS COLUNAS DA TABELA
        self.tabela.coluna = [
          { mPer: 3, tipo: 'RF-Checkbox-Model', chave: 'id', chaveModel: [ 'tabela', 'checkbox', 'id' ] },
          { mPer: 1, chave: 'id', nome: 'Cód.' },
          { mPer: 2, chave: 'nome', nome: 'Nome', tipo: 'link-servico', converte: { id: 'id', nome: 'nome', status: 'status' }, mostrarButton: true },
          { mPer: 1, chave: 'id_cat_nome', nome: 'Categoria' }
        ]

        self.filtroBuscarServico(self, function () {
          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabela = tabelaSuccess

            // SETA O STATUS DA TABELA
            self.tabela.status = ''

            // SETA O STATUS DE PESQUISANDO
            self.formulario.buttons.pesquisa.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA VERIRICAR OS CHECKBOX MARCADOS
            self.filtroVerificaValorMarcadoExisteTabela(function () {
              self.filtroTratarInput(true)
            }, true)
          }, self.filtroSetarStatusGeral)
        })
      },
      filtroBuscarServico: function (self, callback, qtdeTotal = -1) {
        if (qtdeTotal === -1 || self.tabela.linha.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: self.tabela.linha.length, qty: 1000 }, field: { id: null, nome: null, id_cat: { j: { nome: null } }, status: null } }

          // INICIA A CHAVE WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          if (this.formulario.field.hasOwnProperty('categoria')) {
            // PEGA OS VALORES SELECIONADOS
            var categoria = this.formulario.field.categoria.value

            // VERIFICA SE DEVE FILTRAR POR CATEGORIA
            if (categoria.join() !== 't') {
              queryGet.where.aAnd.push({ f: 'id_cat', o: 'in', v: categoria.join() })
            }

            var mensagem = null
            if (categoria.length === 0) {
              mensagem = 'Selecione uma categoria ou clique em selecionar todos para continuar sua pesquisa.'
            }

            if (mensagem !== null) {
              // APRESENTA A MENSAGEM PARA O CLIENTE
              this.$store.state.msgWarn('WEB [400]: ' + mensagem, 'warning')

              // LIMPA O QUERYGET PARA PARAR A BUSCA
              queryGet = null

              // SETA O STATUS DE PESQUISANDO
              self.formulario.buttons.pesquisa.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          if (queryGet !== null) {
            self.$store.state.comunicaAPI('/servico/get', 'POST', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.tabela.linha = self.tabela.linha.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
  
              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroBuscarServico(self, callback, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          }
  
        } else {
          callback()
        }
      },
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=

      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      // => FUNÇÕES PRODUTOS
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      filtroProdutoCategoria: function (self, qtdeTotal = null) {
        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.categoria = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Categoria: ',
              id: self.formulario.id + '--categoria',
              multiple: true,
              allRegistro: 'Todos',
              value: this.cpntFiltros.categoria,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (qtdeTotal === -1 || self.formulario.field.categoria.options.length < qtdeTotal) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: self.formulario.field.categoria.options.length, qty: 1000 }, field: { id: null, nome: null } }
    
            self.$store.state.comunicaAPI('/produto/categoria/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.formulario.field.categoria.options = self.formulario.field.categoria.options.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroProdutoCategoria(self, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          } else {
            self.filtrosFinalizar('filtroProdutoCategoria')
          } 
        }
      },
      filtroProdutoMarca: function (self, qtdeTotal = null) {
        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.marca = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Marca: ',
              id: self.formulario.id + '--marca',
              multiple: true,
              allRegistro: 'Todos',
              value: this.cpntFiltros.marca,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (qtdeTotal === -1 || self.formulario.field.marca.options.length < qtdeTotal) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: self.formulario.field.marca.options.length, qty: 1000 }, field: { id: null, nome: null } }
    
            self.$store.state.comunicaAPI('/produto/marca/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.formulario.field.marca.options = self.formulario.field.marca.options.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroProdutoMarca(self, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          } else {
            self.filtrosFinalizar('filtroProdutoMarca')
          }
        }
      },
      filtroTabelaProdutoIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'tabela-filtros-' + this.cpntTipo,
          linha: [],
          requestId: 0,
          montarTabelaCompleta: false,
          checkbox: { id: this.cpntCheckbox },
          // filtros: {
          //   id: '=',
          //   nome: null,
          //   id_uni: '='
          // }
        }

        // SETA AS COLUNAS DA TABELA
        self.tabela.coluna = [
          { mPer: 3, tipo: 'RF-Checkbox-Model', chave: 'id', chaveModel: [ 'tabela', 'checkbox', 'id' ] },
          { mPer: 1, chave: 'codigo', nome: 'Cód.' },
          { mPer: 2, chave: 'nome', nome: 'Nome', tipo: 'link-produto', converte: { id: 'id', nome: 'nome', status: 'status' }, mostrarButton: true },
          { mPer: 1, chave: 'id_uni', nome: 'Unidade' },
          { mPer: 1, chave: 'id_cat_nome', nome: 'Categoria' },
          { mPer: 1, chave: 'id_mar_nome', nome: 'Marca' },
        ]

        self.filtroBuscarProduto(self, function () {
          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabela = tabelaSuccess

            // SETA O STATUS DA TABELA
            self.tabela.status = ''

            // SETA O STATUS DE PESQUISANDO
            self.formulario.buttons.pesquisa.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA VERIRICAR OS CHECKBOX MARCADOS
            self.filtroVerificaValorMarcadoExisteTabela(function () {
              self.filtroTratarInput(true)
            }, true)
          }, self.filtroSetarStatusGeral)
        })
      },
      filtroBuscarProduto: function (self, callback, qtdeTotal = -1) {
        if (qtdeTotal === -1 || self.tabela.linha.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: self.tabela.linha.length, qty: 1000 }, field: { id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } }, id_uni: null, status: null } }

          // INICIA A CHAVE WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          if (self.formulario.field.hasOwnProperty('categoria') || self.formulario.field.hasOwnProperty('marca')) {
            // PEGA OS VALORES SELECIONADOS
            var categoria = self.formulario.field.categoria.value
            var marca = self.formulario.field.marca.value

            // VERIFICA SE DEVE FILTRAR POR CATEGORIA
            if (categoria.join() !== 't') {
              queryGet.where.aAnd.push({ f: 'id_cat', o: 'in', v: categoria.join() })
            }

            // VERIFICA SE DEVE FILTRAR POR MARCA
            if (marca.join() !== 't') {
              queryGet.where.aAnd.push({ f: 'id_mar', o: 'in', v: marca.join() })
            }

            var mensagem = null
            if (categoria.length === 0 && marca.length === 0) {
              mensagem = 'Selecione uma categoria e uma marca ou clique em selecionar todos para continuar sua pesquisa.'
            } else if (categoria.length === 0) {
              mensagem = 'Selecione uma categoria ou clique em selecionar todos para continuar sua pesquisa.'
            } else if (marca.length === 0) {
              mensagem = 'Selecione uma marca ou clique em selecionar todos para continuar sua pesquisa.'
            }

            if (mensagem !== null) {
              // APRESENTA A MENSAGEM PARA O CLIENTE
              this.$store.state.msgWarn('WEB [400]: ' + mensagem, 'warning')

              // LIMPA O QUERYGET PARA PARAR A BUSCA
              queryGet = null

              // SETA O STATUS DE PESQUISANDO
              self.formulario.buttons.pesquisa.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }
          
          if (queryGet !== null) {
            self.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.tabela.linha = self.tabela.linha.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
  
              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroBuscarProduto(self, callback, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          }
        } else {
          callback()
        }
      },
      // ====================================================================================================================

      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      // => FUNÇÕES CONTATOS
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      filtroContatoTipo: function (self, qtdeTotal = null) {
        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, null, null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.tp_contato = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Tipo de contato: ',
              id: self.formulario.id + '--tp_contato',
              multiple: true,
              allRegistro: 'Todos',
              value: this.cpntFiltros.tp_contato,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (qtdeTotal === -1 || self.formulario.field.tp_contato.options.length < qtdeTotal) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: self.formulario.field.tp_contato.options.length, qty: 1000 }, field: { id: null, nome: null } }
    
            self.$store.state.comunicaAPI('/contato/tipo/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.formulario.field.tp_contato.options = self.formulario.field.tp_contato.options.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroContatoTipo(self, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          } else {
            self.filtrosFinalizar('filtroContatoTipo')
          } 
        }
      },
      filtroTabelaContatoIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'tabela-filtros-' + this.cpntTipo,
          checkbox: { id: this.cpntCheckbox },
          linha: [],
          requestId: 0,
          montarTabelaCompleta: false,
          // filtros: {
          //   id: '=',
          //   nome: null,
          //   cnpj_cpf: 'numeros'
          // }
        }

        // SETA AS COLUNAS DA TABELA
        self.tabela.coluna = [
          { mPer: 3, tipo: 'RF-Checkbox-Model', chave: 'id', chaveModel: [ 'tabela', 'checkbox', 'id' ] },
          { mPer: 1, chave: 'id', nome: 'Cód.' },
          // { mPer: 1, chave: 'nome', nome: 'Nome', tipo: 'link-contato', converte: { id: 'id', nome: 'nome', status: 'status' }, mostrarButton: true },
          { mPer: 1, chave: 'nome', tipo: 'link-contato', nome: 'Nome', converte: { id: 'id', nome: 'nome', empresa: 'empresa', pessoa: 'pessoa', status: 'status' }, mostrarButton: true },
          { mPer: 1, chave: 'cnpj_cpf', nome: 'CNPJ/CPF' },
          { mPer: 1, chave: 'id_tp_con_nome', nome: 'Tipo Contato' }
        ]

        self.filtroBuscarContato(self, function () {
          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabela = tabelaSuccess

            // SETA O STATUS DA TABELA
            self.tabela.status = ''

            // SETA O STATUS DE PESQUISANDO
            self.formulario.buttons.pesquisa.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA VERIRICAR OS CHECKBOX MARCADOS
            self.filtroVerificaValorMarcadoExisteTabela(function () {
              self.filtroTratarInput(true)
            }, true)
          }, self.filtroSetarStatusGeral)
        })
      },
      filtroBuscarContato: function (self, callback, qtdeTotal = -1) {
        if (qtdeTotal === -1 || self.tabela.linha.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: self.tabela.linha.length, qty: 1000 }, field: { id: null, nome: null, empresa: null, cnpj_cpf: null, pessoa: null, id_tp_con: { j: { nome: null } }, status: null } }

          // INICIA A CHAVE WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          if (this.formulario.field.hasOwnProperty('tp_contato')) {
            // PEGA OS VALORES SELECIONADOS
            var tp_contato = this.formulario.field.tp_contato.value

            // VERIFICA SE DEVE FILTRAR POR CATEGORIA
            if (tp_contato.join() !== 't') {
              queryGet.where.aAnd.push({ f: 'id_tp_con', o: 'in', v: tp_contato.join() })
            }

            var mensagem = null
            if (tp_contato.length === 0) {
              mensagem = 'Selecione um tipo de contato ou clique em selecionar todos para continuar sua pesquisa.'
            }

            if (mensagem !== null) {
              // APRESENTA A MENSAGEM PARA O CLIENTE
              this.$store.state.msgWarn('WEB [400]: ' + mensagem, 'warning')

              // LIMPA O QUERYGET PARA PARAR A BUSCA
              queryGet = null

              // SETA O STATUS DE PESQUISANDO
              self.formulario.buttons.pesquisa.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          if (queryGet !== null) {
            self.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.tabela.linha = self.tabela.linha.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
  
              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroBuscarContato(self, callback, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          }
        } else {
          callback()
        }
      },
      // ====================================================================================================================

      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      // => FUNÇÕES  VEICULOS
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      filtroVeiculoContato: function (self, qtdeTotal = null) {
        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.contato = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Proprietário: ',
              id: self.formulario.id + '--contato',
              multiple: true,
              allRegistro: 'Todos',
              value: this.cpntFiltros.contato,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (qtdeTotal === -1 || self.formulario.field.contato.options.length < qtdeTotal) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: self.formulario.field.contato.options.length, qty: 1000 }, field: { id: null, nome: null } }

            // INICIA A CHAVE WHERE
            queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }
    
            self.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.formulario.field.contato.options = self.formulario.field.contato.options.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroVeiculoContato(self, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          } else {
            self.filtrosFinalizar('filtroVeiculoContato')
          } 
        }
      },
      filtroVeiculoMarca: function (self, qtdeTotal = null) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.marca = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Marca: ',
              id: self.formulario.id + '--marca',
              multiple: true,
              allRegistro: 'Todos',
              value: this.cpntFiltros.marca,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (qtdeTotal === -1 || self.formulario.field.marca.options.length < qtdeTotal) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: self.formulario.field.marca.options.length, qty: 1000 }, field: {} }
            var route = ''

            switch (self.$store.state.flagBuscaVei) {
              case true:
                queryGet.field = { id: null, j_marca: { a: 'nome' } }
                route = '/referencia/vei-marca/get/'
                break
              
              case false:
                queryGet.field = { id: null, nome: null }
                route = '/veiculo/marca/get/'
                break
            }
    
            self.$store.state.comunicaAPI(route, 'GET', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.formulario.field.marca.options = self.formulario.field.marca.options.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroVeiculoMarca(self, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          } else {
            self.filtrosFinalizar('filtroVeiculoMarca')
          }
        }
      },
      filtroVeiculoModelo: function (self, qtdeTotal = null) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.modelo = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Modelo: ',
              id: self.formulario.id + '--modelo',
              multiple: true,
              allRegistro: 'Todos',
              value: this.cpntFiltros.modelo,
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if ([ 't', '' ].indexOf(self.formulario.field.marca.value.join()) !== -1) {
            // SETA O CAMPO PARA TODOS
            self.formulario.field.modelo.value = [ 't' ]

            // DESATIVA O CAMPO ENQUANTO O VALOR NÃO ESITVER PREENCHIDO
            self.formulario.field.modelo.disabled = true

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO SE ESTIVER INICIANDO
            if (self.formulario.iniciados.indexOf('filtroVeiculoModelo') === -1) {
              self.filtrosFinalizar('filtroVeiculoModelo')
            }
          } else {
            // ATIVA O CAMPO ENQUANTO O VALOR ESITVER PREENCHIDO
            self.formulario.field.modelo.disabled = false

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            if (qtdeTotal === -1 || self.formulario.field.modelo.options.length < qtdeTotal) {
              // MONTA O QUERY GET
              var queryGet = { type: 'list', limit: { row: self.formulario.field.modelo.options.length, qty: 1000 }, field: {} }
              var route = ''
  
              switch (self.$store.state.flagBuscaVei) {
                case true:
                  queryGet.field = { id: null, j_modelo: { a: 'nome' } }
                  route = '/referencia/vei-modelo/get/'
                  queryGet.where = { aAnd: [ { f: 'id_marca', o: 'in', v: self.formulario.field.marca.value.join() }, { aOr: [ { f: 'clu_create', o: '=', v: self.$store.state.token.clu }, { f: 'clu_create', o: 'isNull' } ] } ] }
                  break
                
                case false:
                  queryGet.field = { id: null, nome: null }
                  route = '/veiculo/modelo/get/'
                  break
              }
     
              self.$store.state.comunicaAPI(route, 'GET', queryGet, function (apiSuccess) {
                // SETA OS VALORES RECEBIDOS
                self.formulario.field.modelo.options = self.formulario.field.modelo.options.concat(apiSuccess.data)
      
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
  
                // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
                self.filtroVeiculoModelo(self, Number(apiSuccess.countAll))
              }, self.filtroSetarStatusGeral)
            } else {
              // CHAMA A FUNÇÃO SE ESTIVER INICIANDO
              if (self.formulario.iniciados.indexOf('filtroVeiculoModelo') === -1) {
                self.filtrosFinalizar('filtroVeiculoModelo')
              }
            }
          }
        }
      },
      filtroPetEspecie: function (self, qtdeTotal = null) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.especie = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Especie: ',
              id: self.formulario.id + '--especie',
              multiple: true,
              allRegistro: 'Todos',
              value: [ '', null, undefined ].indexOf(self.cpntFiltros.especie) === -1 ? self.cpntFiltros.especie : [ 't' ],
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if (qtdeTotal === -1 || self.formulario.field.especie.options.length < qtdeTotal) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: self.formulario.field.especie.options.length, qty: 1000 }, field: {} }

            queryGet.field = { id: null, j_especie: { a: 'nome' } }
    
            self.$store.state.comunicaAPI('/referencia/pet-especie/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA OS VALORES RECEBIDOS
              self.formulario.field.especie.options = self.formulario.field.especie.options.concat(apiSuccess.data)
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
              self.filtroPetEspecie(self, Number(apiSuccess.countAll))
            }, self.filtroSetarStatusGeral)
          } else {
            self.filtrosFinalizar('filtroPetEspecie')
          }
        }
      },
      filtroPetRaca: function (self, qtdeTotal = null) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
          if (qtdeTotal === null) {
            // SETA O CAMPO CATEGORIA
            self.formulario.field.raca = {
              tamanho: 74,
              tipo: 'select2-chosen',
              nome: 'Raça: ',
              id: self.formulario.id + '--raca',
              multiple: true,
              allRegistro: 'Todos',
              value: [ '', null, undefined ].indexOf(self.cpntFiltros.raca) === -1 ? self.cpntFiltros.raca : [ 't' ],
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [],
              onChange: self.filtroParaRelatorioOnChangeValue
            }

            // SETA O VALOR PARA INICIAR A BUSCA
            qtdeTotal = -1

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }

          if ([ 't', '' ].indexOf(self.formulario.field.especie.value.join()) !== -1) {
            // SETA O CAMPO PARA TODOS
            self.formulario.field.raca.value = [ 't' ]

            // DESATIVA O CAMPO ENQUANTO O VALOR NÃO ESITVER PREENCHIDO
            self.formulario.field.raca.disabled = true

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO SE ESTIVER INICIANDO
            if (self.formulario.iniciados.indexOf('filtroPetRaca') === -1) {
              self.filtrosFinalizar('filtroPetRaca')
            }
          } else {
            // ATIVA O CAMPO ENQUANTO O VALOR ESITVER PREENCHIDO
            self.formulario.field.raca.disabled = false

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            if (qtdeTotal === -1 || self.formulario.field.raca.options.length < qtdeTotal) {
              // MONTA O QUERY GET
              var queryGet = { type: 'list', limit: { row: self.formulario.field.raca.options.length, qty: 1000 }, field: { id: null, j_subespecie: { a: 'nome' } } }

              // ADICIONA O FILTRO SELECIONADO PARA ESPECIE
              queryGet.where = { f: 'id_especie', o: 'in', v: self.formulario.field.especie.value.join() }
     
              self.$store.state.comunicaAPI('/referencia/pet-subespecie/get/', 'GET', queryGet, function (apiSuccess) {
                // SETA OS VALORES RECEBIDOS
                self.formulario.field.raca.options = self.formulario.field.raca.options.concat(apiSuccess.data)
      
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
  
                // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
                self.filtroPetRaca(self, Number(apiSuccess.countAll))
              }, self.filtroSetarStatusGeral)
            } else {
              // CHAMA A FUNÇÃO SE ESTIVER INICIANDO
              if (self.formulario.iniciados.indexOf('filtroPetRaca') === -1) {
                self.filtrosFinalizar('filtroPetRaca')
              }
            }
          }
        }
      },
      filtroTabelaPetIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'tabela-filtros-' + this.cpntTipo,
          checkbox: { id: this.cpntCheckbox },
          linha: [],
          requestId: 0,
          montarTabelaCompleta: false,
          // filtros: {
          //   placa: null,
          //   id_con_nome: null
          // }
        }

        // SETA AS COLUNAS DA TABELA
        self.tabela.coluna = [
          { mPer: 3, tipo: 'RF-Checkbox-Model', chave: 'id', chaveModel: [ 'tabela', 'checkbox', 'id' ] },
          { mPer: 2, chave: 'nome', tipo: 'link-pet', nome: 'Nome', click: false, converte: { id: 'id', nome: 'nome', status: 'status' }, mostrarButton: true },
          { mPer: 2, chave: 'id_con_nome', tipo: 'link-contato', nome: 'Proprietário', click: false, converte: { id: 'id_con', nome: 'id_con_nome', empresa: 'id_con_empresa', pessoa: 'id_con_pessoa', status: 'id_con_status' }, mostrarButton: true },
          // { mPer: 1, chave: 'id_mar_nome', nome: 'Modelo' },
          // { mPer: 1, chave: 'id_mod_nome', nome: 'Marca' },
          { mPer: 1, chave: 'id_pet_especie_nome', nome: 'Espécie' },
          { mPer: 1, chave: 'id_pet_subespecie_nome', nome: 'Raça' }
        ]

        self.filtroBuscarPet(self, function () {
          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabela = tabelaSuccess

            // SETA O STATUS DA TABELA
            self.tabela.status = ''

            // SETA O STATUS DE PESQUISANDO
            self.formulario.buttons.pesquisa.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA VERIRICAR OS CHECKBOX MARCADOS
            self.filtroVerificaValorMarcadoExisteTabela(function () {
              self.filtroTratarInput(true)
            }, true)
          }, self.filtroSetarStatusGeral)
        })
      },
      filtroTabelaVeiculoIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'tabela-filtros-' + this.cpntTipo,
          checkbox: { id: this.cpntCheckbox },
          linha: [],
          requestId: 0,
          montarTabelaCompleta: false,
          // filtros: {
          //   placa: null,
          //   id_con_nome: null
          // }
        }

        // SETA AS COLUNAS DA TABELA
        self.tabela.coluna = [
          { mPer: 3, tipo: 'RF-Checkbox-Model', chave: 'id', chaveModel: [ 'tabela', 'checkbox', 'id' ] },
          { mPer: 2, chave: 'placa', tipo: 'link-veiculo', nome: 'Placa', click: false, converte: { id: 'id', placa: 'placa', status: 'status' }, mostrarButton: true },
          { mPer: 2, chave: 'id_con_nome', tipo: 'link-contato', nome: 'Proprietário', click: false, converte: { id: 'id_con', nome: 'id_con_nome', empresa: 'id_con_empresa', pessoa: 'id_con_pessoa', status: 'id_con_status' }, mostrarButton: true },
          { mPer: 1, chave: 'id_mar_nome', nome: 'Modelo' },
          { mPer: 1, chave: 'id_mod_nome', nome: 'Marca' },
          { mPer: 1, chave: 'ano', nome: 'Ano' }
        ]

        self.filtroBuscarVeiculo(self, function () {
          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabela = tabelaSuccess

            // SETA O STATUS DA TABELA
            self.tabela.status = ''

            // SETA O STATUS DE PESQUISANDO
            self.formulario.buttons.pesquisa.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA VERIRICAR OS CHECKBOX MARCADOS
            self.filtroVerificaValorMarcadoExisteTabela(function () {
              self.filtroTratarInput(true)
            }, true)
          }, self.filtroSetarStatusGeral)
        })
      },
      filtroBuscarVeiculo: function (self, callback, qtdeTotal = -1) {
        if (qtdeTotal === -1 || self.tabela.linha.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: self.tabela.linha.length, qty: 1000 }, field: {} }

          // INICIA A CHAVE WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          // SETA OS CAMPOS QUE DEVEM SER CARREGADOS
          queryGet.field = { id: null, placa: null, status: null, id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } }, ano: null, id_mar: { j: { nome: null } }, id_mod: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }

          // PEGA OS VALORES DOS FILTROS
          var marca = self.formulario.field.marca.value.join()
          var modelo = self.formulario.field.modelo.value.join()
          var proprietario = self.formulario.field.contato.value.join()

          if ([ 't', '' ].indexOf(marca) === -1 || [ 't', '' ].indexOf(modelo) === -1) {
            switch (self.$store.state.flagBuscaVei) {
              case true:
                // VERIFICA SE DEVE FILTRAR PELO CAMPO MARCA
                if ([ 't', '' ].indexOf(marca) === -1) {
                  queryGet.where.aAnd.push({ m: 'vei_modelo', f: 'id_marca', o: 'in', v: marca })
                }

                // VERIFICA SE DEVE FILTRAR PELO CAMPO MODELO
                if ([ 't', '' ].indexOf(modelo) === -1) {
                  queryGet.where.aAnd.push({ f: 'ref_modelo', o: 'in', v: modelo })
                }
                break
              
              case false:
                // queryGet.field = { id: null, nome: null }
                // route = '/veiculo/modelo/get/'
                break
            }
          }

          // VERIFICA SE DEVE FILTRAR PELO CAMPO MODELO
          if ([ 't', '' ].indexOf(proprietario) === -1) {
            queryGet.where.aAnd.push({ f: 'id_con', o: 'in', v: proprietario })
          }

          self.$store.state.comunicaAPI('/veiculo/get', 'POST', queryGet, function (apiSuccess) {
            // REALIZA O FOR PARA CRIAR OS CAMPOS PERSONALIZADOS
            for (var key in apiSuccess.data) {
              if (apiSuccess.data[key].hasOwnProperty('ref_modelo') && apiSuccess.data[key].ref_modelo !== '') {
                apiSuccess.data[key].id_mod_nome = apiSuccess.data[key].ref_modelo_j_modelo
                apiSuccess.data[key].id_mar_nome = apiSuccess.data[key].ref_modelo_id_marca_j_marca
              }
            }

            // SETA OS VALORES RECEBIDOS
            self.tabela.linha = self.tabela.linha.concat(apiSuccess.data)
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
            self.filtroBuscarVeiculo(self, callback, Number(apiSuccess.countAll))
          }, self.filtroSetarStatusGeral)
        } else {
          callback()
        }
      },
      filtroBuscarPet: function (self, callback, qtdeTotal = -1) {
        if (qtdeTotal === -1 || self.tabela.linha.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: self.tabela.linha.length, qty: 1000 }, field: {} }

          // INICIA A CHAVE WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          // SETA OS CAMPOS QUE DEVEM SER CARREGADOS
          queryGet.field = { id: null, nome: null, status: null, id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' }, id_especie: { j: { j_especie: { a: 'id_pet_especie_nome' } } } } } }

          // PEGA OS VALORES DOS FILTROS
          var especie = self.formulario.field.especie.value.join()
          var raca = self.formulario.field.raca.value.join()
          var proprietario = self.formulario.field.contato.value.join()

          // ADICIONA O FILTRO DE MARCA A BUSCA
          if ([ 't', '' ].indexOf(especie) === -1) {
            queryGet.where.aAnd.push({ m: 'pet_subespecie', f: 'id_especie', o: 'in', v: especie })
          }

          // ADICIONA O FILTRO DE MODELO A BUSCA
          if ([ 't', '' ].indexOf(raca) === -1) {
            queryGet.where.aAnd.push({ f: 'id_pet_subespecie', o: 'in', v: raca })
          }

          // VERIFICA SE DEVE FILTRAR PELO CAMPO MODELO
          if ([ 't', '' ].indexOf(proprietario) === -1) {
            queryGet.where.aAnd.push({ f: 'id_con', o: 'in', v: proprietario })
          }

          self.$store.state.comunicaAPI('/pet/get', 'POST', queryGet, function (apiSuccess) {
            // SETA OS VALORES RECEBIDOS
            self.tabela.linha = self.tabela.linha.concat(apiSuccess.data)
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
            self.filtroBuscarPet(self, callback, Number(apiSuccess.countAll))
          }, self.filtroSetarStatusGeral)
        } else {
          callback()
        }
      },
      // ====================================================================================================================

      filtroTratarInput: function (pesquisar = false, requestId = 0) {
        var self = this

        if (pesquisar === false) {
          // SETA O ID DO REQUEST
          var id = Math.floor(Math.random() * (9999 - 1000)) + 1000

          // SETA O ID DO REQUEST
          self.tabela.requestId = id

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // AGUARDA PARA VERIFICAR SE O REQUEST É O MESMO
          setTimeout(function () {
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA VERIFICAR SE É O MESMO REQUEST
            self.filtroTratarInput(true, id)
          }, 300)
        } else if (requestId === self.tabela.requestId) {
          // if (self.$store.state.FUN_VALIDA_INFORMACAO(self.tabela.coluna) === -1) {
          //   // PEGA O ID DA COLUNA
          //   var indexColuna = self.tabela.coluna.findIndex(item => item.chave === self.tabela.checkboxEditar && item.tipo === 'RF-Checkbox')

          //   // SETA OS CHECKBOX MARCADOS
          //   if (indexColuna !== -1) {
          //     self.tabela.coluna[indexColuna].checked = self.tabela.checkbox
          //   }
          // }

          // PEGA OS VALOES DO CAMPO
          this.tabela.checkbox.id = this.cpntCheckbox

          if (self.filtroInput === '') {
            self.tabela.linhaTab = self.tabela.linha
          } else {
            // CONVERTE TODA A STRING PARA MINUSCULO
            var procurado = self.filtroInput.toLowerCase()

            self.tabela.linhaTab = self.tabela.linha.filter(function (item) {
              var valor = ''
              var validaTipo = ''
              var resultado = false

              for (var key in self.tabela.filtros) {
                valor = item[key].toLowerCase()
                validaTipo = self.tabela.filtros[key]

                if (resultado === false && validaTipo === '=') {
                  resultado = valor === procurado
                }

                if (resultado === true) {
                  break
                }

                if (resultado === false && validaTipo === null) {
                  resultado = valor.indexOf(procurado) !== -1
                }

                if (resultado === true) {
                  break
                }

                if (resultado === false && validaTipo === 'numeros') {
                  resultado = valor.replace(/[^0-9]/g,'').indexOf(procurado) !== -1
                }

                if (resultado === true) {
                  break
                }
              }

              return resultado
            })  
          }
        }       

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      }
    },
    watch: {
      filtroInput: function () {
        this.filtroTratarInput(false, 0)
      }
    }
  }
</script>
